import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { GA, WebEngage, DeepBI, PGAD } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";
import { fetchConstituencyDetail, fetchCandidatesList, fetchCandidatesPageList } from "../../../api";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import loader from "../../../../assets/images/loader.gif";
import LoksabhaElectionCommentsWidget from "../../rows/loksabha-election-comment-widget";
import StoryCardVertical from "../../atoms/story-card-vertical";
import ConstituencySearchBar from "../../atoms/constituency-searchbar";
// import PollSurveyWidget from "../../rows/election-survey-poll-widget";
import LoksabhaElectionPoll from "../../rows/loksabha-election-poll";
import TnelectionHeader2026 from "../../rows/tnelection-header-2026";

const StoryList = ({ stories }) => {
  return (
    <React.Fragment>
      {stories.length > 0 ? (
        stories.map((story, idx) => (
          <div key={idx} className={styles["story-card"]}>
            <StoryCardVertical story={story} key={story.id} />
          </div>
        ))
      ) : (
        <h3 className={styles["no-results"]}>No results found</h3>
      )}
    </React.Fragment>
  );
};

StoryList.propTypes = {
  stories: PropTypes.arrayOf(StoryCardVertical.propTypes.story)
};

const LoksabhaDetailPage = ({ data }) => {
  const [constituency, setConstituency] = useState([]);
  const [candidatesList, setCandidatesList] = useState({});
  const slug = get(data, ["slug"], "");
  const stories = get(data, ["stories"], null);

  useEffect(() => {
    fetchConstituencyDetail(slug)
      .then(res => {
        const resData = get(res, ["data", "items"]);
        setConstituency(resData);
      })
      .catch(console.error);
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.TN_ELECTION_PAGE, { collection: data });
    DeepBI.registerPageView({ collection: data });
    PGAD.loadScript();
  }, []);

  useEffect(() => {
    fetchCandidatesList(slug)
      .then(res => {
        const resData = get(res, ["data", "items", "constituency_info"], null);
        resData && setCandidatesList(resData);
      })
      .catch(console.error);
  }, []);

  // Fetch candidates on mount using slug
  useEffect(
    () => {
      if (!slug) return;
      fetchCandidatesPageList(slug)
        .then(res => {
          const resData = get(res, ["data", "items"]);
          setCandidatesList(resData || []);
        })
        .catch(console.error);
    },
    [slug]
  );
  // Extract data
  const title = get(constituency, ["area"], null);
  const pic = get(constituency, ["area_image"], null);
  let description = get(constituency, ["description"], "");
  description = description.replace(/(<([^>]+)>)/gi, "");
  const femaleVoters = get(constituency, ["female_voters"], 0) || 0;
  const maleVoters = get(constituency, ["male_voters"], 0) || 0;
  const othersVoters = get(constituency, ["others"], 0) || 0;
  const MlaPic = get(constituency, ["current_mla_image"], null);
  const currentMla = get(constituency, ["current_mla"], null);
  const currentMlaParty = get(constituency, ["current_mla_party"], null);
  const districtName = get(constituency, ["district_name"], null);
  const storyLink = get(constituency, ["article_url"], null);
  const totalPeople = get(constituency, ["total_voters"], 0) || 0;
  // const constituencySlug = get(constituency, ["thokkuthi_slug"], null);
  const partyId = get(constituency, ["party_id"], null);
  const areaEn = get(constituency, ["area_en"], null);
  const thokkuthiSlug = get(constituency, ["thokkuthi_slug"], null);

  const entries = candidatesList && typeof candidatesList === "object" ? Object.entries(candidatesList) : [];
  // Display logic
  const displayValue = value => {
    if (value === null || value === undefined || value === 0 || value === "") {
      return "-";
    }
    return value.toLocaleString();
  };

  const [isAccordionOpen, setAccordionOpen] = useState(false);

  const candidatesCards =
    entries.length !== 0 &&
    entries.map((slide, idx) => {
      return (
        <div className={styles["candidate-card"]} key={"candidate-" + idx}>
          <div className={styles["candidate-header"]}>
            <h3 className={styles["candidate-team"]}>{slide[1].alliance_name}</h3>
          </div>
          <div className={styles["candidate-image-wrapper"]}>
            {slide[1].star_candidate !== 0 && <Icon type="star" className={styles["star-icon"]} />}
            <img
              src={`${slide[1].candidate_image}`}
              alt={slide[1].candidate_name}
              className={styles["candidate-img"]}
            />
          </div>
          <div className={styles["candidate-info"]}>
            <h4 className={styles["candidate-name"]}>{slide[1].candidate_name}</h4>
            <span className={styles["candidate-party"]}>({slide[1].party_name})</span>
          </div>
        </div>
      );
    });

  return (
    <React.Fragment>
      <div className={`main-page styles-m__base__2vtxy js-story-main-container ${styles["base-class"]}`}>
        <div className="page-content infinity-page">
          <TnelectionHeader2026 showMenu={true} />
          <div className={`container ${styles["page-container"]}`}>
            {/* Breadcrumb */}
            {/* <ul className={styles["breadcrumb-wrapper"]}>
              <li className={styles["breadcrumb"]}>
                <Link aria-label="breadcrumb" href="/">
                  முகப்பு
                </Link>
              </li>
              <li className={styles["breadcrumb"]}>
                <Link aria-label="breadcrumb" href="/tamil-nadu-assembly-election-2026">
                  சட்டமன்ற தேர்தல் 2026
                </Link>
              </li>
              <li className={styles["breadcrumb"]}>
                <Link
                  aria-label="தொகுதி பக்கம்"
                  href={`/election/tn-assembly-election-2026/constituency/${constituencySlug}`}
                >
                  {title}
                </Link>
              </li>
            </ul> */}

            {title ? (
              <React.Fragment>
                {/* OUTER GREY DIV */}
                <div className={styles["outer-grey-wrapper"]}>
                  {/* SECTION 1 - ROW 1: Search Bar */}

                  <div className={styles["top-sections"]}>
                    {/* Accordion for Constituency Search */}
                    <div className={styles["accordion-wrapper"]}>
                      <div className={styles["accordion-header"]} onClick={() => setAccordionOpen(prev => !prev)}>
                        <div className={styles["accordion-txt"]}>
                          <h1 className={styles["form-txt"]}>
                            <span>தொகுதி</span>
                            <span>360</span>
                          </h1>
                          <div className={styles["form-search"]}>
                            <div className={`${styles["form-search-text"]} hidden-desktop`}>
                              தொகுதி கள நிலவரங்களுக்கு...
                            </div>
                            <div className={`${styles["form-search-text"]} hidden-mobile`}>
                              உங்கள் தொகுதியின் கள நிலவரங்கள் மற்றும் விரிவான அலசல்களைப் பெற்றிட
                            </div>
                            <span
                              className={`${styles["accordion-arrow"]} ${
                                isAccordionOpen ? styles["open"] : styles["closed"]
                              }`}
                              aria-label={isAccordionOpen ? "Collapse" : "Expand"}
                            >
                              <Icon type={isAccordionOpen ? "close" : "search"} className={styles["arrow-icon"]} />
                            </span>
                          </div>
                        </div>
                      </div>
                      {isAccordionOpen && (
                        <div className={styles["section-1"]}>
                          <ConstituencySearchBar slug={slug} />
                        </div>
                      )}
                    </div>

                    <div className={styles["section-2"]}>
                      {/* District Badges */}
                      <div className={styles["district-info-row"]}>
                        <div className={styles["district-badge"]}>
                          <span className={styles["district-label"]}>மாவட்டம்</span>
                          <span className={styles["district-value"]}>{districtName}</span>
                        </div>
                        <div className={styles["district-badge"]}>
                          <span className={styles["district-label"]}>{`சட்டமன்றத் தொகுதி - ${title}`}</span>
                        </div>
                      </div>

                      {/* <div className={styles["title-row"]}>
                      <h1>{`சட்டமன்றத் தொகுதி - ${title}`}</h1>
                    </div> */}

                      {/*   Stats Cards */}
                      <div className={styles["stats-grid"]}>
                        <div className={styles["stat-card-total"]}>
                          <span className={styles["stat-label"]}>மொத்தம்</span>
                          <span className={styles["stat-value"]}>{displayValue(totalPeople)}</span>
                        </div>
                        <div className={styles["stat-card"]}>
                          <img
                            src="https://media.vikatan.com/vikatan/2021-03/2067d6de-28c2-4f63-a294-cedf4672f9a5/male.png"
                            alt="ஆண்கள்"
                            className={styles["stat-icon"]}
                          />
                          <div className={styles["stat-content"]}>
                            <span className={styles["stat-label"]}>ஆண்கள்</span>
                            <span className={styles["stat-value"]}>{displayValue(maleVoters)}</span>
                          </div>
                        </div>
                        <div className={styles["stat-card"]}>
                          <img
                            src="https://media.vikatan.com/vikatan/2021-03/3b51e7f1-9fec-47d6-8985-ce84bc4fada1/female.png"
                            alt="பெண்கள்"
                            className={styles["stat-icon"]}
                          />
                          <div className={styles["stat-content"]}>
                            <span className={styles["stat-label"]}>பெண்கள்</span>
                            <span className={styles["stat-value"]}>{displayValue(femaleVoters)}</span>
                          </div>
                        </div>
                        <div className={styles["stat-card"]}>
                          <img
                            src="https://media.vikatan.com/vikatan/2021-03/c4f95fdb-d2db-4c72-b184-e4e1af726574/transgender.png"
                            alt="மூ.பாலினத்தவர்"
                            className={styles["stat-icon"]}
                          />
                          <div className={styles["stat-content"]}>
                            <span className={styles["stat-label"]}>மூ.பாலினத்தவர்</span>
                            <span className={styles["stat-value"]}>{displayValue(othersVoters)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Candidates Section (Outside grey wrapper) */}
                  {candidatesCards && (
                    <div className={styles["candidates-section"]}>
                      <h2 className={styles["section-title"]}>2026 {title} வேட்பாளர்கள்</h2>
                      <div className={styles["candidates-grid"]}>{candidatesCards}</div>
                    </div>
                  )}

                  <div className={styles["inner-white-wrapper"]}>
                    {/* SECTION 2 - ROW 2: District Info + Stats Cards */}

                    {/* SECTION 3 - ROW 3: 3 Columns */}
                    <div className={styles["section-3"]}>
                      {/* Column 1: Main Image + Description */}
                      <div className={styles["column-1"]}>
                        <div className={styles["title-row"]}>
                          <h1>{`சட்டமன்றத் தொகுதி - ${title}`}</h1>
                        </div>
                        {pic && (
                          <div className={styles["main-image-wrapper"]}>
                            <img src={pic} alt={title} className={styles["main-image"]} />
                          </div>
                        )}
                        {description && (
                          <div className={styles["description-content"]}>
                            <p dangerouslySetInnerHTML={{ __html: description }} />
                          </div>
                        )}
                      </div>

                      {/* Column 2: Comments Widget */}
                      <div className={styles["column-2"]}>
                        <LoksabhaElectionCommentsWidget
                          slug={slug}
                          partyId={partyId}
                          title={title}
                          areaEn={areaEn}
                          thokkuthiSlug={thokkuthiSlug}
                        />
                      </div>

                      {/* Column 3: Current MP + Poll Survey */}
                      <div className={styles["column-3"]}>
                        {/* Current MP Card */}
                        <div className={styles["mp-card"]}>
                          <h2 className={styles["mp-card-title"]}>தற்போதைய சட்டமன்ற உறுப்பினர்</h2>
                          {MlaPic && (
                            <div className={styles["mp-image-wrapper"]}>
                              <img src={MlaPic} alt={currentMla} className={styles["mp-image"]} />
                            </div>
                          )}
                          <div className={styles["mp-info"]}>
                            <h3 className={styles["mp-name"]}>{currentMla}</h3>
                            <span className={styles["mp-party"]}>{currentMlaParty}</span>
                            {storyLink && (
                              <Link
                                aria-label="என்ன செய்தார் எம்.எல்.ஏ?"
                                href={`${storyLink}?pfrom=constituency-page`}
                                externalLink={storyLink}
                                className={styles["mp-link"]}
                              >
                                என்ன செய்தார் எம்.எல்.ஏ? <Icon type="double-arrow" />
                              </Link>
                            )}
                          </div>
                        </div>

                        {/* Poll Survey Widget */}
                        <div className={styles["poll-widget"]}>
                          <LoksabhaElectionPoll partyId={partyId} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stories Section (Outside grey wrapper) */}
                {stories &&
                  stories.length > 0 && (
                    <div className={styles["stories-section"]}>
                      {/* <h2 className={styles["section-title"]}>{`சட்டமன்ற தேர்தல் 2026- ${title} தொகுதி`}</h2> */}
                      <h2 className={styles["section-title"]}>{`சட்டமன்ற தேர்தல் 2026`}</h2>
                      <div className={styles["stories-grid"]}>
                        <StoryList stories={stories} />
                      </div>
                    </div>
                  )}
              </React.Fragment>
            ) : (
              <div className={styles["loader-wrapper"]}>
                <img alt="Loading..." src={assetify(loader)} className={styles["loader"]} />
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export { LoksabhaDetailPage };

LoksabhaDetailPage.propTypes = {
  data: PropTypes.shape()
};
